/* models/sources/remote_data_source.js */ function _(require, module, exports) {
    const web_data_source_1 = require(287) /* ./web_data_source */;
    const p = require(18) /* ../../core/properties */;
    class RemoteDataSource extends web_data_source_1.WebDataSource {
        constructor(attrs) {
            super(attrs);
        }
        get_column(colname) {
            const column = this.data[colname];
            return column != null ? column : [];
        }
        initialize() {
            super.initialize();
            this.setup();
        }
        static init_RemoteDataSource() {
            this.define({
                polling_interval: [p.Number],
            });
        }
    }
    exports.RemoteDataSource = RemoteDataSource;
    RemoteDataSource.__name__ = "RemoteDataSource";
    RemoteDataSource.init_RemoteDataSource();
}
